const Bowser = require("bowser");

const OS = Object.freeze({
  MAC: "MacOS",
  IOS: "iOS",
  WIN: "Windows",
  ANDROID: "Android",
  LINUX: "Linux",
});

const getUserOS = () => {
  const userAgent = window.navigator.userAgent,
    platform =
      window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = [
      "iPhone",
      "iPad",
      "iPod",
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
    ];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "MacOS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
};

const getUserBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  console.log("BROWSER123", browser.getBrowser());
  return browser.getBrowser().name;
};

const isMobileDevice = () => {
  const os = getUserOS();

  return os === OS.IOS || os === OS.ANDROID;
};

module.exports = {
  OS,
  getUserOS,
  getUserBrowser,
  isMobileDevice,
};
